import { observable, action, makeObservable } from 'mobx';
import { createContext, Context } from 'react';
import { InputType } from './inputs/types';

let context: Context<FormStore> | null = null;
let inputs: string[] | null = null;
export class FormStore {
  @observable inputs: InputType[] = [];

  constructor(newInputs: InputType[]) {
    makeObservable(this);
    this.setInputs(newInputs);
  }

  @action setInputs = (newInputs: InputType[]) => {
    this.inputs = newInputs;
  };

  @action
  getData = () => {
    const data: any = {};
    this.inputs.forEach((input) => {
      // check if it is a assetList
      if (
        input.dataType !== '[]string' &&
        input.dataType !== '[]url' &&
        input.dataType !== '[]datetime' &&
        input.dataType !== '[]number' &&
        input.dataType !== '[]@prop' &&
        input.dataType.indexOf('[]') >= 0
      ) {
        const assetList = input.value;

        data[input.tag] = assetList
          ? (assetList as Record<string, any>[]).map((asset: any) => {
              return { '@key': asset['@key'] };
            })
          : null;
      } else {
        data[input.tag] = input.value;
      }
    });
    return data;
  };

  @action
  toggleInputsDisabled = () => {
    this.inputs.forEach((input) => {
      if (input.toggleDisabled) {
        input.toggleDisabled();
      }
    });
  };

  @action
  clearInputs = () => {
    this.inputs.forEach((input) => {
      if (input.clearValue) {
        input.clearValue();
      }
    });
  };
}

// Reset the cached form context (call on unmount to avoid stale data)
export const resetFormStoreContext = () => {
  context = null;
  inputs = null;
};

// singleton
export const FormStoreContext = (f: InputType[]) => {
  const fTags = f.map(({ tag }) => tag); // getting tags
  const sameInputs: boolean = JSON.stringify(fTags) === JSON.stringify(inputs);
  // Check if context already exists and if the inputs are the same
  if (context && sameInputs) {
    return context;
  }
  inputs = fTags;
  context = createContext(new FormStore(f));
  return context;
};
